import { CrontabPool } from './crontab/crontab-pool';
import { LoginCheckCrontab } from './login-check';

export const initializationCrontab = () => {
  const crontabPool = new CrontabPool();

  const loginCheck = new LoginCheckCrontab(crontabPool);
  loginCheck.addCrontabPool({
    workspaceID: 1,
    triggerTimes: ['*'],
  });
};
